import { SVGProps, forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Box, BoxProps, Link } from '@mui/material';
import { LogoIcon } from '@commons/logo';
import { useSettingContext } from '@hooks/useSettingContext';
import Image from '@commons/image';
import { Foodsa } from '@PorkyCol/utils';

interface Props extends BoxProps {
  company?: boolean;
  disabledLink?: boolean;
  disabledBg?: boolean;
  fill?: string;
  sx?: any;
  variant?: 'circle' | 'text';
  width?: number;
  height?: number;
  svgProps?: SVGProps<SVGSVGElement>;
}

const Logo = forwardRef(
  (
    {
      company,
      width = 40,
      svgProps,
      height = 40,
      disabledBg,
      fill = '#000',
      variant,
      disabledLink = false,
      sx,
      ...other
    }: Props,
    ref
  ) => {
    const { setting, logoBs64 } = useSettingContext();
    const sxBox = {
      width,
      height,
      display: 'inline-flex',
      ...sx,
    };
    if (disabledBg) {
      sxBox.background = 'transparent';
    }
    const logo = (
      <Box ref={ref} component="div" sx={sxBox} {...other}>
        {company && setting?.logo ? (
          <Image disabledEffect sx={{ borderRadius: '50%' }} alt="logo company" src={logoBs64} />
        ) : (
          <Foodsa
            className="text-white"
            fill={fill}
            height={String(height)}
            width={String(height)}
            {...svgProps}
          />
        )}
      </Box>
    );

    if (disabledLink) {
      return <>{logo}</>;
    }

    return (
      <Link to="/dashboard" component={RouterLink} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
